import styled from 'styled-components'
import breakpoints from 'utils/consts/breakpoints'
import { hideScrollbar, lineClamp } from 'components/Common/GlobalStyles'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
  z-index: 2;
  min-height: 126px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    flex-wrap: nowrap;
    overflow-x: auto;
    margin: 0 -32px;
    padding: 0 24px;

    ${hideScrollbar};
  }

  @media screen and ${breakpoints.device.mobile} {
    margin: 0 -16px;
    padding: 0 8px;
  }
`
export const Award = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 84px;
  height: 110px;
  padding: 6px;
  background: white;
  border: 1.5px solid #d8d9ed;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 84px;
  margin: 8px;
  scroll-snap-align: start;
`
export const MedalWrapper = styled.div`
  position: absolute;
  right: -7px;
  top: -7px;
`
export const Main = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Year = styled.div`
  font-size: 10px;
  line-height: 140%;
  font-weight: 600;
  color: var(--color-night);
  margin-bottom: 4px;
`
export const Name = styled.div`
  font-size: 8px;
  line-height: 140%;
  height: ${8 * 1.4 * 2}px;
  font-weight: 600;
  color: var(--color-night);
  text-align: center;

  ${lineClamp(2)}
`
export const Points = styled.div`
  font-size: 18px;
  line-height: 140%;
  height: ${18 * 1.4}px;
  font-weight: 600;
  color: var(--color-brand-red);
  white-space: nowrap;
`
export const Footer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 7px;
  line-height: 140%;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--color-night);
  height: ${7 * 1.4 * 2}px;
  max-width: 100%;
`
export const MedalType = styled.div`
  max-width: 100%;
  ${lineClamp(1)}
`

export const Trophy = styled.div`
  font-weight: 600;
  max-width: 100%;
  ${lineClamp(1)}
`
